<!-- 新闻详情 -->
<template>
  <transition name="el-fade-in-linear">
    <div id="newsDetail">
      <headerVue></headerVue>
      <div class="container" v-loading="loading">
        <div class="inner">
          <div v-if="pdfUrl" class="pdfviewer">
            <!-- 电子期刊 pdf -->
            <div v-if="_isMobile" class="pdfviewer" :class="{ isFull: isFull }">
              <button @click="isFull = !isFull" class="btn-fullsize">
                {{ !isFull ? "全屏观看" : "退出全屏" }}
              </button>
              <PDFViewer style="height: 100%; width: 100vw" :controls="['zoom', 'switchPage']" :source="pdfUrl"
                @loaded="loading = false" />
            </div>
            <!-- <table v-else>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td> -->
            <iframe style="width: 100%; height: 768px;display:block;" :src="pdfUrl"></iframe>
            <!-- </td>
            </tr>
            <tr>
              <td>-----------cccc页面尾--------</td>
            </tr>
          </table> -->

          </div>
          <div v-if="!isPdf">
            <h2 v-if="this.$route.query.email">
              主席信箱：{{ this.$route.query.email }}
            </h2>
            <div v-else>
              <h2>{{ this.articleInfo.title }}</h2>
              <div class="smallTitle">
                <span>发布日期：{{ this.articleInfo.releaseTime.slice(0, -3) }}</span>
                <span>来源：{{ this.articleInfo.articleFrom }}</span>
                <span>浏览量：{{ this.articleInfo.hits }}</span>
                <span v-show="this.articleInfo.author">作者：{{ this.articleInfo.author }}</span>
              </div>
            </div>
            <!-- 文章内容 -->
            <div class="content">
              <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor" v-html="safeHtmlContent"></div>
              <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            </div>
          </div>
        </div>
      </div>
      <footerVue></footerVue>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue'
import headerVue from "../index/header.vue";
import footerVue from "../foot/foot.vue";
import axios from "axios";
import PDFViewer from "pdf-viewer-vue/dist/vue2-pdf-viewer";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.filter('formatter', function (value) {
  // return value.replace(/<p>/g, '<p style="text-indent: 2em;text-align:justify;">');
  return value.replace(/<p>/g, '<p style="text-indent: 2em;text-align:justify;font-size: 16px;">');

});

export default {
  name: "newsDetail",
  components: {
    headerVue,
    footerVue,
    PDFViewer,
  },
  data() {
    return {
      currentPage: 1,
      pageCount: 0,
      loading: true,
      isFull: false,
      isPdf: false,
      pdfUrl: "",
      // pdfUrl: 'https://edu.siwonet.com:9090/solution/300%E6%A0%A1%E5%9B%AD%E6%96%87%E5%8C%96%E5%BB%BA%E8%AE%BE%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88.pdf',
      articleInfo: {
        title: "",
        releaseTime: "",
        articleFrom: "",
        author: "",
        articleContent: "",
      },
      _isMobile: false,
    };
  },
  computed: {
    safeHtmlContent() {
      // 在这里应用过滤器
      return this.$options.filters.formatter(this.articleInfo.articleContent);
    }
  },
  created() {
    this._isMobile = Boolean(
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    );
    // console.log(" this._isMobile", this._isMobile);
    this.getArticleDetail();
    this.showEBook();
  },
  updated() {
    // 处理 v-html 解析富文本中有图片的情况
    // let DomList = document
    //   .getElementsByClassName("content")[0]
    //   .querySelectorAll("img");
    // console.log(DomList);

    let videoDomList = document
      .getElementsByClassName("content")[0]
      .querySelectorAll("iframe");
    // console.log(videoDomList);

    for (let i in videoDomList) {
      videoDomList[i].style.width = "100%"
      videoDomList[i].style.height = "500px"
    }

    // for (let i in DomList) {
    // console.log('DomList[i]',DomList[i]);
    // if (DomList[i].style) {
    //   if (DomList[i].src.indexOf("/prod-api/profile") != -1) {
    //   } else {
    //     DomList[i].src =
    //       DomList[i].src.substr(0, 33) +
    //       "/prod-api/profile/" +
    //       DomList[i].src.substr(33);
    //   }
    //   console.log(DomList[i].src);
    //   DomList[i].style.width = "100%";
    // }

    // if (DomList[i].src.startsWith('/prod-api/profile')) {
    //   console.log('富文本图片路径以/prod-api/profile开头');
    // } else {
    //   console.log('富文本图片路径不以/prod-api/profile开头');
    //   DomList[i].src = '/prod-api/profile' + DomList[i].src;
    //   console.log(DomList[i].src);
    // }
    // }
  },

  methods: {
    // 处理显示pdf文件
    showEBook() {
      // console.log(this.$route.query.tm);
      // console.log('-------------处理显示pdf文件------------------');
      axios({
        // url: 'https://jiusan.htseasky.com:9001/prod-api/api/business/journal/desc' + "?id=" + this.$route.query.tm,
        url: 'http://www.shx93.gov.cn/prod-api/api/business/journal/desc' + "?id=" + this.$route.query.tm,
        method: 'get',
        headers: {
          'Content-Type': 'application/pdf'
        },
      }).then((res) => {
        // console.log("res.data", res);
        let pdfurl =
          "http://www.shx93.gov.cn/prod-api" + res.data.data.fileUrl;
        if (this._isMobile) {
          this.pdfUrl = pdfurl;
        } else {
          this.downloadPdf(pdfurl);
        }
      }).catch((error) => {
        // console.log(error);
      });
    },
    downloadPdf(url) {
      axios({
        url: url,
        method: "get",
        responseType: "blob",
        headers: {},
      })
        .then((res) => {
          // console.log("res.data", res);
          this.pdfUrl = window.URL.createObjectURL(res.data);
          this.loading = false;
          // console.log('pdfUrl', this.pdfUrl);
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    // -------  替换图片链接 --------start
    replaceImg(a) {
      // a 为富文本的字符串内容，为了测试，只写了img标签
      var b = /< img [^>]*src=['"]([^'"]+)[^>]*>/g; // img 标签取src里面内容的正则
      var s = a.match(b); // 取到所有img标签 放到数组 s里面
      if (s) {
        for (var i = 0; i < s.length; i++) {
          var srcImg = s[i].replace(b, '$1'); // 取src面的内容
          // 这里用来拼接
          var baseUrl = '/prod-api/profile';
          if (srcImg != '' && srcImg != undefined) {
            if (srcImg.startsWith('/prod-api/profile')) {
              // console.log('富文本图片路径以/prod-api/profile开头');
            } else {
              // console.log('富文本图片路径不以/prod-api/profile开头');
              // 修改富文本字符串内容 img标签src 相对路径改为绝对路径
              a = a.replace(/src=['"]([^'"]+)[^>]*>/gi, 'src="' + baseUrl + srcImg + '"' + '>');
              // console.log(srcImg);
            }
          }
        }
      }
      return a
    },
    // -------  替换图片链接 --------end
    // 获取新闻详情信息
    async getArticleDetail() {
      // console.log('aaid',this.$route.query.tm);
      if (this.$route.query.title) {
        let res = await this.$api.nav.getSpecific(this.$route.query.title);
        this.articleInfo.title = res.data.data.title;
        this.articleInfo.releaseTime = res.data.data.releaseTime;
        this.articleInfo.articleFrom = res.data.data.articleFrom;
        this.articleInfo.author = res.data.data.author;
        this.articleInfo.articleContent = res.data.data.articleContent;
        this.loading = false;
      } else {
        let res = await this.$api.nav.getArticleDesc(this.$route.query.tm);
        this.isPdf = !Boolean(res.data.data);
        if (this.isPdf) return;
        // console.log("详情----------", res.data.data);
        this.articleInfo.title = res.data.data.title;
        this.articleInfo.releaseTime = res.data.data.releaseTime;
        this.articleInfo.articleFrom = res.data.data.articleFrom;
        this.articleInfo.author = res.data.data.author;
        this.articleInfo.articleContent = res.data.data.articleContent;
        this.articleInfo.hits = res.data.data.hits;
        this.loading = false;
        // console.log('this.articleInfo', this.articleInfo);

        // ------- 处理富文本图片信息 start
        // 匹配图片URL的正则表达式
        const imageRegex = /<img.*?src="(.*?)".*?>/g;

        // 替换图片URL
        // const replacedArticleContent = this.articleInfo.articleContent.replace(imageRegex, (match, url) => {
        //   return `<p align="center"><img src="${this.processUrl(url)}" alt="Image"></p>`;
        // });
        const replacedArticleContent = this.replaceImg(this.articleInfo.articleContent)

        // console.log('---替换图片后内容');
        // console.log(replacedArticleContent);
        this.articleInfo.articleContent = replacedArticleContent;
        //------- 处理富文本图片信息 end

        // console.log('this.articleInfo.articleContent', this.articleInfo.articleContent);
        // // 筛选出 p 标签
        // const div = document.createElement('div');
        // div.innerHTML = this.articleInfo.articleContent;
        // const pTags = div.querySelectorAll('p');
        // for (let i = 0; i < pTags.length; i++) {
        //   // 每一个 p 标签
        //   let pTag = pTags[i];
        //   // 去除 p 标签的标签符号，获取内容
        //   const content = pTag.textContent;
        //   // 构建带有样式的 p 标签
        //   const styledPTag = `<p style="text-indent: 2ch;">${content}</p>`;
        //   // 用替换后的标签替换原始的 p 标签
        //   pTag = styledPTag;
        //   console.log('pTag',pTag);
        //   // this.articleInfo.articleContent = this.articleInfo.articleContent.replace(pTag, styledPTag);
        // }
        // console.log('this.articleInfo.articleContent;', this.articleInfo.articleContent);
      }
    },
  },
};
</script>

<style lang="scss">
.ql-lineheight-5 {
  line-height: 5;
}

ql-lineheight-1-5 {
  line-height: 1.5;
}

ql-lineheight-1-75 {
  line-height: 1.75;
}

ql-lineheight-2 {
  line-height: 2;
}

ql-lineheight-3 {
  line-height: 3;
}

ql-lineheight-4 {
  line-height: 4;
}

ql-lineheight-5 {
  line-height: 5;
}

#newsDetail {
  background-color: #f5f5f5;
}

/*
 滚动条样式
*/
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}

.inner {
  // height:670px ;

  // margin-bottom: 10px;
  box-sizing: border-box;

}

.container {
  background-color: white !important;
  padding: 10px 0px;
  margin-top: 20px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
  overflow-y: scroll;

  box-sizing: border-box;

  .inner {
    padding: 40px 80px;
    overflow-y: scroll;

    h2 {
      font-size: 26px;
      color: #222222;
      font-weight: bold;
      line-height: 38px;
      margin-bottom: 15px;
      text-align: center;
    }

    .smallTitle {
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      margin: 0 10px;
      text-align: center;
      padding-bottom: 55px;
      border-bottom: 1px solid #e9e9e9;

      span {
        margin-right: 30px;
      }
    }

    .content {
      margin-top: 30px;
    }
  }
}

@media screen and (max-width: 768px) {
  // img {
  //   max-width: 120px;
  // }

  .content {
    img {
      width: 95%;
    }

    p {
      img {
        width: 95%;
      }
    }
  }

  .container {
    width: 100% !important;
    padding: 0 !important;
    min-height: 700px;

    h2 {
      font-size: 17px !important;
    }

    .smallTitle {
      padding-bottom: 10px !important;

      span {
        font-size: 13px !important;
      }
    }

    .inner {
      padding: 0px 10px !important;
      box-sizing: border-box;
    }

    .btn-fullsize {
      height: 45px;
      line-height: 45px;
      width: 100%;
    }

    .pdfviewer {
      height: 700px;
      width: 100vw !important;
      max-width: 100vw !important;
      overflow-x: hidden;

      &.isFull {
        z-index: 100;
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        height: 100vh;
      }
    }

    .pdf-viewer {
      min-width: 0;
    }

    .isFull .pdf-viewer {
      height: calc(100vh - 45px) !important;
    }

    .pdf-bar {
      display: flex;
      align-self: center;
      justify-content: center;
      width: 200px;
    }
  }
}

.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409EFF;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}
</style>
